import { render, staticRenderFns } from "./NoConnection.vue?vue&type=template&id=88543056&scoped=true&"
import script from "./NoConnection.vue?vue&type=script&lang=js&"
export * from "./NoConnection.vue?vue&type=script&lang=js&"
import style0 from "./NoConnection.vue?vue&type=style&index=0&id=88543056&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88543056",
  null
  
)

export default component.exports